/** Hotel cards show the currency glyph (₹) instead of the ISO code. */
const CURRENCY_SYMBOLS = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  AED: "AED",
  SAR: "SAR",
  SGD: "S$",
  AUD: "A$",
  CAD: "C$",
  JPY: "¥",
  MYR: "RM",
  THB: "฿",
};

/** Unmapped currencies keep their ISO code so nothing renders blank. */
export const getHotelCurrencySymbol = (currencyCode) =>
  CURRENCY_SYMBOLS[currencyCode] ?? currencyCode ?? "";

/** Card fares are grouped (₹ 15,388) to read like the supplier APIs. */
export const formatHotelCardAmount = (amount) => {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "N/A";
  return n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

/** Stay fares are totals; cards also show the nightly rate like the supplier APIs. */
export const getHotelPerNightAmount = (total, nights) => {
  const amount = Number(total);
  const nightCount = Number(nights);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  if (!Number.isFinite(nightCount) || nightCount <= 0) return null;
  return Math.ceil(amount / nightCount);
};
